(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utbox-esports-home"] && !Shopify.designMode) return;
  try {
    
  function updateUtboxHomePackage(input) {
    var product = input.closest('.utg-product');
    var label = product ? product.querySelector('[data-utg-price-label]') : null;
    var price = product ? product.querySelector('[data-utg-price-value]') : null;
    var compare = product ? product.querySelector('[data-utg-price-compare]') : null;
    var link = product ? product.querySelector('[data-utg-product-link]') : null;
    var baseUrl = link ? link.getAttribute('data-utg-product-url') : '';

    if (!product) {
      return;
    }

    product.querySelectorAll('.utg-package').forEach(function (packageLabel) {
      var packageInput = packageLabel.querySelector('.utg-package__input');
      packageLabel.classList.toggle('utg-package--highlight', packageInput === input);
    });

    if (label) {
      label.textContent = input.getAttribute('data-utg-variant-title') || '';
    }

    if (price) {
      price.textContent = input.getAttribute('data-utg-variant-price') || '';
    }

    if (compare) {
      var comparePrice = input.getAttribute('data-utg-variant-compare') || '';
      compare.textContent = comparePrice;
      compare.hidden = !comparePrice;
    }

    if (link && baseUrl) {
      link.href = baseUrl + '?variant=' + encodeURIComponent(input.value);
    }
  }

  function initUtboxHomePackages(root) {
    root.querySelectorAll('.utg-product').forEach(function (product) {
      var checkedInput = product.querySelector('.utg-package__input:checked');

      if (checkedInput) {
        updateUtboxHomePackage(checkedInput);
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('.utg-package__input')) {
      updateUtboxHomePackage(event.target);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initUtboxHomePackages(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initUtboxHomePackages(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utbox-mobile-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.utboxMobileStickyCtaReady) {
      return;
    }

    window.utboxMobileStickyCtaReady = true;
    var syncQueued = false;
    var bottomOffsetObserver = null;

    function syncBottomOffset() {
      var previewBar = document.getElementById('PBarNextFrameWrapper');
      var cookieBanner = document.getElementById('shopify-pc__banner');
      var bottomBars = [previewBar];
      var offset = 0;
      var cookieVisible = false;

      function isBottomVisible(bar) {
        if (!bar) {
          return false;
        }

        var rect = bar.getBoundingClientRect();
        return rect.height > 0 && rect.bottom >= window.innerHeight - 4;
      }

      bottomBars.forEach(function (bar) {
        if (!bar) {
          return;
        }

        var rect = bar.getBoundingClientRect();
        if (isBottomVisible(bar)) {
          offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top));
        }
      });

      cookieVisible = isBottomVisible(cookieBanner);
      document.documentElement.classList.toggle('utms-cookie-visible', cookieVisible);
      document.documentElement.style.setProperty('--utms-bottom-offset', offset + 'px');
    }

    function scheduleSyncBottomOffset() {
      if (syncQueued) {
        return;
      }

      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncBottomOffset();
      });
    }

    function focusBuyArea(form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });

      window.setTimeout(function () {
        var focusTarget = form.querySelector('button[name="add"], button[type="submit"], select, input');
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }, 420);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-utbox-sticky-submit]');
      if (!trigger || trigger.disabled) {
        return;
      }

      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) {
        return;
      }

      var submit = form.querySelector('button[name="add"], button[type="submit"], [type="submit"]');
      if (submit && !submit.disabled) {
        submit.click();
        return;
      }

      focusBuyArea(form);
    });

    scheduleSyncBottomOffset();
    window.setTimeout(scheduleSyncBottomOffset, 600);
    window.setTimeout(scheduleSyncBottomOffset, 1600);
    window.addEventListener('resize', scheduleSyncBottomOffset, { passive: true });

    if (document.body) {
      bottomOffsetObserver = new MutationObserver(scheduleSyncBottomOffset);
      bottomOffsetObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () {
        if (bottomOffsetObserver) {
          bottomOffsetObserver.disconnect();
        }
      }, 15000);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
